import React from "react";
import { NavLink } from "react-router-dom";

const Login = () => {
  return (
    <section style={{ backgroundColor: "#f1f1f1", height: '100vh' }}>
      <div className="container">
        <div className="logo text-center my-5">
          <NavLink to="/" className="site-ancer">
            <img src="images/logo.png" alt="logo" />
          </NavLink>
        </div>
        <div className="row">
          <div
            className="col-md-3 p-3 m-auto"
            style={{ backgroundColor: "#fff" }}
          >
            <label
              for="email"
              className="form-label"
              style={{ fontSize: "14px" }}
            >
              Username or Email Address
            </label>
            <input type="text" className="form-control mb-4" name="email" />
            <label
              for="password"
              className="form-label"
              style={{ fontSize: "14px" }}
            >
              Password
            </label>
            <input type="password" className="form-control" name="password" />
            <button
              className="py-1 px-3 my-3 text-white"
              style={{ background: "#008ec2" }}
              type="submit"
              name="login"
            >
              Login
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Login;
